import { render, staticRenderFns } from "./BetgameImprint.vue?vue&type=template&id=41fd65ea&scoped=true"
import script from "./BetgameImprint.vue?vue&type=script&lang=js"
export * from "./BetgameImprint.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41fd65ea",
  null
  
)

export default component.exports